import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import { useParams } from 'react-router-dom';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  loadBureauReportDetail,
  LOAD_BUREAU_REPORT_DETAIL
} from 'src/store/actions/bureauReportActions';
import {
  selectBureauReportDetailList,
  selectBureauReportDetailCount,
  selectBureauReportDetailPage,
  selectBureauReportDetailSearchParams,
  selectBureauReportDetailInfo
} from 'src/store/selectors/bureauReportSelector';
import { ReportType } from 'src/utils/constants/buro-reports';
import MonthlyReportDetailTable from './MonthlyReportDetailTable';
import PartialReportDetailTable from './PartialReportDetailTable';

const BuroReportDetailList = () => {
  const dispatch = useDispatch();
  const { reportId } = useParams();

  const bureauReportDetailList = useSelector(selectBureauReportDetailList);
  const count = useSelector(selectBureauReportDetailCount);
  const loading = useSelector(
    isLoadingSelector([LOAD_BUREAU_REPORT_DETAIL.action])
  );
  const success = useSelector(
    successSelector([LOAD_BUREAU_REPORT_DETAIL.action])
  );
  const page = useSelector(selectBureauReportDetailPage) || 0;
  const searchParams = useSelector(selectBureauReportDetailSearchParams);
  const reportInfo = useSelector(selectBureauReportDetailInfo);
  const isPartial = reportInfo?.type === ReportType.PARTIAL;

  useEffect(() => {
    if (!reportId) {
      return;
    }
    dispatch(
      loadBureauReportDetail({
        reportId: Number(reportId),
        page: 0,
        limit: +process.env.REACT_APP_TABLE_SIZE,
        clearSearchParams: true
      })
    );
  }, [dispatch, reportId]);

  const handleChangePage = useCallback(
    (event, value) => {
      if (!reportId) {
        return;
      }
      dispatch(
        loadBureauReportDetail({
          reportId: Number(reportId),
          page: value,
          limit: +process.env.REACT_APP_TABLE_SIZE,
          ...searchParams
        })
      );
    },
    [dispatch, reportId, searchParams]
  );

  if (success && !loading && bureauReportDetailList.length === 0) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.BUREAU_REPORT_DETAIL_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.BUREAU_REPORT_DETAIL_DESCRIPTION"
        />
      </Card>
    );
  }

  const TableComponent = isPartial
    ? PartialReportDetailTable
    : MonthlyReportDetailTable;

  return (
    <TableComponent
      bureauReportDetailList={bureauReportDetailList}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

export default BuroReportDetailList;
